//统一的header
import React, { Component } from 'react';
import { Header} from 'antd/lib/layout/layout';
import './index.css'
import {connect} from 'react-redux'
import { Menu ,Image,Col, Row,Card,Divider,Typography} from 'antd';

import {Link} from 'react-router-dom'
import {

  ProjectOutlined,
  FundViewOutlined,
  HomeOutlined,
  BookOutlined,
  ExperimentOutlined,
  MailOutlined 
} from '@ant-design/icons';
const { Title } = Typography;
class UHeader extends Component {
 
  render() {
    return <Header className="ant-layout-header" style={{ padding: 0 ,height:60 }}> 
      <Menu className="ant-layout-header2" mode="horizontal"  defaultSelectedKeys="1" >
      <Image
          preview={false}
          width={150}
          src={require('../img/RowanLogo2.png')}
        />
        <Menu.Item key="1" icon={<HomeOutlined />}>
          <Link to="/tang/home">Home</Link>
        </Menu.Item>
        <Menu.Item key="2" icon={<FundViewOutlined />}>
          <Link to="/tang/teaching">Teaching</Link>
        </Menu.Item>
        <Menu.Item key="3" icon={<ExperimentOutlined />}>
          <Link to="/tang/research">Research</Link>
        </Menu.Item>
        <Menu.Item key="4" icon={<BookOutlined />}>
          <Link to="/tang/publication">Publication</Link>
        </Menu.Item>
        <Menu.Item key="5" icon={<ProjectOutlined />}>
          <Link to="/tang/projects">Projects</Link>
        </Menu.Item>
        
      </Menu>
      
  </Header>;
  }
}

export default connect(
	state => ({
	}),
	{}
)(UHeader)

